(function () {
  function init() {
    var announcement = document.querySelector('.utility-bar');
    if (!announcement) return;

    var mobileBar = document.querySelector('.lushe-mobile-bar');
    var sidebar = document.querySelector('.lushe-sidebar');
    var ticking = false;

    function update() {
      var offset = Math.max(0, announcement.offsetHeight - window.scrollY);
      var value = offset ? 'translateY(' + offset + 'px)' : '';
      if (mobileBar) mobileBar.style.transform = value;
      if (sidebar) sidebar.style.transform = value;
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  document.addEventListener('DOMContentLoaded', init);
})();
